/* eslint class-methods-use-this: 0 */
import TettraResourceAbstractSchema from './TettraResourceAbstractSchema';
import { ICON, RESOURCE_TYPE } from '../utilities/CONSTANTS';
import { INLINE_REFERENCE_TYPE, FONT_ICON } from '../tettra-editor/utilities/CONSTANTS';

// Example
// {
//     "html_url": "https://github.com/Tettra/tettra-wiki/issues/8638",
//     "id": 1056701365,
//     "number": 8638,
//     "title": "Override email for user",
//     "user": {
//         "login": "AndyGCook",
//         "id": 2079220,
//     },
//     "labels": [
//         {
//             "name": "admin task",
//         }
//     ],
//     "state": "open",
//     "comments": 0,
// }

class GithubIssue extends TettraResourceAbstractSchema {
    constructor(data) {
        super(data);
        this.data = this.constructor.transformData(data);
        this.id = this.data.id;
        this.type = RESOURCE_TYPE.GITHUB_ISSUE;
    }

    static transformData(data) {
        const {
            html_url: url,
            url: apiUrl,
            repository_url,
            id,
            number,
            title,
            user,
            labels,
            state,
            comments: commentCount,
        } = data;
        const githubUserName = user.login;
        const repo = repository_url.split('github.com/repos/').pop();

        return ({
            id, number, url, apiUrl, labels, state, commentCount, githubUserName, title, repo,
        });
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.data.title;
    }

    getSubtitle() {
        return `${this.data.repo} #${this.data.number}`;
    }

    getIcon() {
        if (this.data.state === 'open') {
            return ICON.GITHUB_ISSUE_OPEN;
        } if (this.data.state === 'closed') {
            return ICON.GITHUB_ISSUE_CLOSED;
        }
        return ICON.GITHUB;
    }

    getCustomClass() {
        return 'github';
    }

    getUrl() {
        return this.data.url;
    }

    getEntityData() {
        const {
            id, number, url, apiUrl, title,
        } = this.data;
        const referenceType = INLINE_REFERENCE_TYPE.GITHUB_ISSUE;
        return ({
            referenceType,
            apiUrl,
            url,
            title,
            id,
            metadata: {
                number,
            },
        });
    }

    getFontIcon() {
        return FONT_ICON.GITHUB;
    }

    isInternal() {
        return false;
    }
}

export default GithubIssue;
